var map = {
	"./enviroment.local": 3933,
	"./enviroment.local.js": 3933,
	"./enviroment.production": 1139,
	"./enviroment.production.js": 1139,
	"./enviroment.staging": 7943,
	"./enviroment.staging.js": 7943
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1716;